import { AssetPublishModel } from "src/models/assetModel";
import JustifiedGallery from "../gallerySearch/JustifiedGallery";
import EmptyBox from "../empty/EmptyBox";

interface TypeInterface {
  assets: AssetPublishModel[];
}

export default function GalleryArtist({ assets }: TypeInterface) {
  return (
    assets.length > 0
      ? <JustifiedGallery assets={assets} />
      : <EmptyBox />
  );
}